import { useEffect, useMemo, useState } from 'react'
import { Box, Button, Card, CardContent, Checkbox, Collapse, Grid2, IconButton, Typography } from '@mui/material';
import TabComponentsForCourse from '../../shared/components/Tabs/TabComponentsForCourse';
import TabPanel from '../../shared/components/Tabs/TabPanel';
import CustomDivider from '../../shared/utils/CustomDivider';
import useTabs from '../../shared/hook/useTabs';
import TabForSprints from '../../shared/components/Tabs/TabForSprints';
import { BOX_SHADOW, Constants, Page_Padding } from '../../shared/constants';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import useResponsive from '../../shared/utils/Responsive';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { useNewCourseDetail1 } from '../../assets/api/useGetApi';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';
import api from '../../assets/api/usePostApi';
import useVisitedPathStore from '../../shared/store/useVisitedPathStore';
import useAuthStore from '../../shared/store/useAuthStore';
import { useToaster } from '../../shared/utils/ToasterProvider';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const CoursePurchased = () => {
    const { slug, apartments_id } = useParams();
    const { data: newCoursesDetail, isLoading } = useNewCourseDetail1({ slug: slug, apartments_id: apartments_id })
    const isSmallScreen = useResponsive("sm")
    const { value, handleChange } = useTabs(0);
    // const { value: sprintTab, handleChange: handleChangeSprints } = useTabs(0);

    const TopSection = ({ item }) => {
        const finalSprintPrice = item.sprints.reduce((total, sprint) => {
            const reduction = parseFloat(sprint.reduction_price);
            const price = parseFloat(sprint.price);

            const effectivePrice = (!isNaN(reduction) && reduction > 0)
                ? reduction
                : (!isNaN(price) ? price : 0);

            return total + effectivePrice;
        }, 0);

        return (
            <Grid2 container spacing={"2rem"} px={Page_Padding}>
                <Grid2 size={{ xs: 12, md: 7 }}>
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            mb: 2
                        }}
                    >
                        <Typography variant='h5'>{item.milestone_name}</Typography>
                        <Typography variant='h5' sx={{ display: "flex", alignItems: "center" }}>
                            <CurrencyRupeeIcon sx={{ color: "red.main" }} />
                            {finalSprintPrice}
                        </Typography>


                    </Box>
                    <Typography variant='body2' color='grey.400' mb={1}> <span className='dateheading'>From Date : </span>  {item?.start_date}&nbsp; &nbsp; &nbsp;  <span className='dateheading'>To Date</span> : {item?.end_date}</Typography>

                    {item.description && <>
                        <Typography variant='body1' color='grey.400' mb={1}>
                            Description
                        </Typography>
                        <Typography variant='body2' color='grey.400'>
                            {item?.description}
                        </Typography>
                    </>

                    }
                    <CustomDivider size={"1rem"} />

                    {
                        item?.learningOutcome && <>
                            <Typography variant='body1' color='grey.400' mb={1}>
                                Learning Outcome
                            </Typography>
                            <Typography variant='body2' color='grey.400'>
                                {item?.learningOutcome}
                            </Typography>
                        </>
                    }




                </Grid2>
                <Grid2 size={{ xs: 12, md: 5 }}>
                    <img src={Constants.customImages.PurchasedImg} width={"100%"} />
                </Grid2>
            </Grid2>
        )
    }
    const [accordionChecks2, setAccordionChecks2] = useState([]);
    const [accordionChecks1, setAccordionChecks1] = useState([]);
    // const totalPrice = accordionChecks1.flat().reduce((sum, sprint) => {
    //     if (sprint.checked && sprint.sprints?.price) {
    //         return sum + parseFloat(sprint.sprints.price);
    //     }
    //     return sum;
    // }, 0);

    const totalPrice = accordionChecks2.reduce((sum, milestone) => {
        return sum + milestone.sprints.reduce((milestoneSum, sprint) => {
            if (sprint.checked) {
                const reductionPrice = parseFloat(sprint.sprints?.reduction_price);
                const regularPrice = parseFloat(sprint.sprints?.price);

                const priceToUse = (!isNaN(reductionPrice) && reductionPrice > 0)
                    ? reductionPrice
                    : (!isNaN(regularPrice) ? regularPrice : 0);

                return milestoneSum + priceToUse;
            }
            return milestoneSum;
        }, 0);
    }, 0);


    useEffect(() => {
        const milestones = newCoursesDetail?.data?.[0]?.milestones || [];
        const dynamicChecks = milestones.map(milestone => {
            const sprints = milestone?.sprints || [];
            return sprints.map(sprint => ({
                sprints: sprint,
                checked: true,
            }));
        });

        setAccordionChecks1(dynamicChecks);
    }, [newCoursesDetail]);


    useEffect(() => {
        const milestones = newCoursesDetail?.data?.[0]?.milestones || [];

        const dynamicChecks = milestones.map(milestone => {
            const sprints = milestone?.sprints || [];
            return {
                start_date: milestone?.start_date,
                end_date: milestone?.end_date,
                milestone_name: milestone?.milestone_name,
                sprints: sprints.map(sprint => ({
                    sprints: sprint,
                    checked: true,
                }))
            };
        });

        setAccordionChecks2(dynamicChecks);
    }, [newCoursesDetail]);




    function filterCourseByChecks(course, accordionChecks) {
        if (!course?.milestones || !accordionChecks) return course;

        const filteredMilestones = course.milestones.map((milestone, idx) => {
            const sprintChecksWrapper = accordionChecks[idx]?.sprints || [];

            // Keep only the checked sprints
            const filteredSprints = sprintChecksWrapper
                .filter(sprintCheck => sprintCheck.checked === true)
                .map(sprintCheck => sprintCheck.sprints);

            return {
                ...milestone,
                sprints: filteredSprints,
            };
        });

        return {
            ...course,
            milestones: filteredMilestones,
        };
    }
    const filteredCourse = filterCourseByChecks(newCoursesDetail?.data?.[0], accordionChecks2);
    const handleAccordionCheckChange = (milestoneIndex, sprintIndex, checked) => {
        setAccordionChecks2(prev => {
            return prev.map((milestone, mIdx) => {
                if (mIdx !== milestoneIndex) return milestone;

                const updatedSprints = milestone.sprints.map((sprint, sIdx) =>
                    sIdx === sprintIndex
                        ? { ...sprint, checked }
                        : sprint
                );

                return {
                    ...milestone,
                    sprints: updatedSprints,
                };
            });
        });
    };
    const [, forceUpdate] = useState(0);

    useEffect(() => {
        forceUpdate(n => n + 1);
    }, [accordionChecks2]);
    const handleCheckboxChange = (tabIndex) => {
        setAccordionChecks2(prev => {
            const isAllChecked = prev[tabIndex].sprints.every(sprint => sprint.checked);

            const updated = prev.map((milestone, i) =>
                i === tabIndex
                    ? {
                        ...milestone,
                        sprints: milestone.sprints.map(sprint => ({
                            ...sprint,
                            checked: !isAllChecked,
                        })),
                    }
                    : milestone
            );

            setCheckedTabs(prevTabs => {
                const newTabs = [...prevTabs];
                newTabs[tabIndex] = !isAllChecked;
                return newTabs;
            });

            return updated;
        });
    };

    const [checkedTabs, setCheckedTabs] = useState([false, false]);
    const [open, setOpen] = useState(false);
    const location = useLocation();
    const token = useAuthStore((state) => state.accessToken);
    const user = useAuthStore((state) => state.user);
    const navigate = useNavigate();
    const { showToaster } = useToaster();
    const createOrderMutation = useMutation({
        mutationFn: (formData) => api.post("collab-course-create-order", formData, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }),
    });

    const handlePayment = () => {
        if (!token) {
            useVisitedPathStore.getState().setLastVisitedPath(location.pathname);
            localStorage.setItem("lastVisitedPath", location.pathname);
            navigate("/StudentLogin")
            return
        }

        const obj = {
            "event_id": newCoursesDetail?.data?.[0]?.course_id,
            "price": totalPrice,
            "quantity": 1,
            "apartments_id": apartments_id,
            "order_details": filteredCourse,
            "details": {
                "firstname": user?.firstname,
                "lastname": user?.lastname,
                "email": user.email
            }
        }
        createOrderMutation.mutate(obj, {
            onSuccess: (order) => {
                if (!order?.data?.payment_order_id) {
                    showToaster('Warning!', 'Failed to get order ID from server', 'warning')
                    return;
                };

                const options = {
                    key: order?.data?.key,
                    amount: order?.data?.amount,
                    currency: "INR",
                    name: "Myskill.club",
                    description: "Payment for courses",
                    order_id: order?.data?.payment_order_id,
                    handler: async (response) => {

                        const paymentData = {
                            razorpay_payment_id: response.razorpay_payment_id,
                            razorpay_order_id: response.razorpay_order_id,
                            razorpay_signature: response.razorpay_signature,
                            event_id: newCoursesDetail?.data?.[0]?.course_id,
                            price: totalPrice,
                            quantity: 1,
                            apartments_id: apartments_id,
                            details: {
                                firstname: user?.firstname,
                                lastname: user?.lastname,
                                email: user.email,
                                course_name: newCoursesDetail?.data?.[0]?.course_name,
                                start_date: newCoursesDetail?.data?.[0]?.batch_start_date,
                                end_date: newCoursesDetail?.data?.[0]?.batch_end_date,
                                start_time: "",
                                end_time: "",
                                apartname_name: newCoursesDetail?.data?.[0]?.apartment_name,
                            }
                        };
                        try {
                            const verifyResponse = await api.post("collab-course-payment-callback", paymentData, {
                                headers: {
                                    Authorization: `Bearer ${token}`,
                                },
                            });
                            if (verifyResponse?.data?.message) {
                                // handleOpenSuccessPay()
                                // toast.success(verifyResponse?.data?.message, { position: "top-right", theme: "light" });
                                // window.location.href = `https://myskill.club/studentdashboard/student/dashboard`;
                            } else {
                                showToaster('Error', verifyResponse?.data?.message, 'error');
                            }
                        } catch (error) {
                            showToaster('Error', error.response?.data?.message, 'error');
                        }
                    },
                    theme: { color: "#DC143C" }
                };
                const rzp = new window.Razorpay(options);
                rzp.open();
            },
            onError: (error) => {
                showToaster('Error', error.response?.data?.message || "Payment initiation failed", 'error');
            },
        });
    };

    const [openIndexes, setOpenIndexes] = useState([]);

    const toggleAccordion = (index) => {
        setOpenIndexes(prev => {
            const newIndexes = prev.includes(index)
                ? prev.filter(i => i !== index)
                : [...prev, index];
            return newIndexes;
        });
    };

    const renderAccordian = () => {
        return (
            <>
                {accordionChecks2?.map((sprintsArray, milestoneIndex) => (
                    <Box key={milestoneIndex} mb={2}>
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                cursor: 'pointer',
                                p: 1,
                                borderRadius: 1,
                            }}
                            onClick={() => toggleAccordion(milestoneIndex)}
                        >
                            <Box sx={{ display: 'flex', gap: 1 }}>
                                <Checkbox
                                    checked={accordionChecks2[milestoneIndex].sprints.every(sprint => sprint?.checked === true)}
                                    onClick={(e) => e.stopPropagation()}
                                    onChange={() =>
                                        handleCheckboxChange(milestoneIndex)
                                    }
                                    sx={{
                                        color: 'red.main',
                                        '&.Mui-checked': { color: 'red.main' },
                                    }}
                                />
                                <Box>
                                    <Typography
                                        variant="body1"
                                        color={
                                            sprintsArray?.sprints?.some((item) => item.checked === false)
                                                ? 'grey.400'
                                                : 'inherit'
                                        }
                                    >
                                        {sprintsArray?.milestone_name}
                                    </Typography>

                                    <Typography variant="body2" color="grey.400" mb={1} fontSize="0.7rem">
                                        <span>From Date : </span>{sprintsArray?.start_date}&nbsp;&nbsp;&nbsp; <span>To Date :</span> {sprintsArray?.end_date}
                                    </Typography>
                                </Box>

                            </Box>

                            <IconButton size="small" onClick={(e) => {
                                e.stopPropagation();
                                toggleAccordion(milestoneIndex);
                            }}>
                                {openIndexes.includes(milestoneIndex) ? (
                                    <ExpandLessIcon />
                                ) : (
                                    <ExpandMoreIcon />
                                )}
                            </IconButton>

                        </Box>

                        <Collapse in={openIndexes.includes(milestoneIndex)} timeout="auto" unmountOnExit sx={{ bgcolor: "#F8F8F8" }}>
                            {sprintsArray?.sprints?.map((item, lessonIndex) => (
                                <Box key={lessonIndex} sx={{ display: 'flex', alignItems: 'start', mt: 1, ml: 2 }}>
                                    <Checkbox
                                        checked={item.checked || false}
                                        onClick={(e) => e.stopPropagation()}
                                        onChange={(e, checked) =>
                                            handleAccordionCheckChange(milestoneIndex, lessonIndex, checked)
                                        }
                                        sx={{
                                            color: 'red.main',
                                            '&.Mui-checked': { color: 'red.main' },
                                        }}
                                    />
                                    <Box>
                                        <Typography variant="body2" color={item.checked ? 'inherit' : 'grey.600'}>
                                            {item.sprints?.sprint_name}
                                        </Typography>
                                        <Typography
                                            variant="body2"
                                            color="grey.400"
                                            mb={1}
                                            fontSize="0.8rem"
                                            sx={{ display: 'flex', alignItems: 'center' }}
                                        >
                                            <CurrencyRupeeIcon sx={{ color: 'red.main', fontSize: 15 }} />
                                            {(() => {
                                                const reduction = parseFloat(item.sprints?.reduction_price);
                                                const price = parseFloat(item.sprints?.price);
                                                return !isNaN(reduction) && reduction > 0
                                                    ? reduction
                                                    : !isNaN(price)
                                                        ? price
                                                        : 0;
                                            })()}
                                        </Typography>
                                    </Box>
                                </Box>
                            ))}
                        </Collapse>
                    </Box>
                ))}
            </>
        )
    }


    const allTabs = useMemo(() => {
        return accordionChecks2?.map((sprintsArray, milestoneIndex) => {
            return sprintsArray?.sprints?.map((sprintObj, sprintIndex) => ({
                label: sprintObj.sprints?.sprint_name,
                component: (
                    <>
                        <Box px={Page_Padding}>
                            <img src={Constants.customImages.PurchasedSprint} width="100%" alt="Purchased Sprint" />
                            <CustomDivider size="1rem" />
                            <Grid2 container spacing="2rem">
                                <Grid2 size={{ xs: 12, sm: 7 }}>
                                    <Typography variant="h5">{sprintObj?.sprints?.sprint_name || 'Sprint Name'}</Typography>

                                    {sprintObj?.sprints?.description && <>
                                        <Typography variant='body1' color='grey.400' mb={1}>
                                            Description
                                        </Typography>
                                        <Typography variant='body2' color='grey.400'>
                                            {sprintObj?.sprints?.description}
                                        </Typography>
                                    </>

                                    }
                                    <CustomDivider size={"1rem"} />

                                    {
                                        sprintObj?.sprints?.learningOutcome && <>
                                            <Typography variant='body1' color='grey.400' mb={1}>
                                                Learning Outcome
                                            </Typography>
                                            <Typography variant='body2' color='grey.400'>
                                                {sprintObj?.sprints?.learningOutcome}
                                            </Typography>
                                        </>
                                    }
                                    <Typography variant="body2" fontWeight="400" mb={2}>List Of Lessons</Typography>

                                    {sprintObj.sprints?.sessions?.map((item, index) => (
                                        <Box key={index} sx={{ display: "flex", alignItems: "stretch" }}>
                                            <Box sx={{
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center",
                                                width: "1rem",
                                                pr: "1rem"
                                            }}>
                                                <Box sx={{
                                                    width: "0.7rem",
                                                    height: "0.7rem",
                                                    bgcolor: "red.main",
                                                    borderRadius: "50%",
                                                    transform: "scale(1.1)",
                                                    border: "2px solid #D9D9D9"
                                                }} />
                                                {index !== 5 && <Box sx={{ width: "0.2rem", bgcolor: "#D9D9D9", flexGrow: 1 }} />}
                                            </Box>
                                            <Box pb="1rem">
                                                <Typography variant="body2" fontWeight="400">{item?.name}</Typography>
                                            </Box>
                                        </Box>
                                    ))}
                                </Grid2>

                                {!isSmallScreen && (
                                    <Grid2 size={{ xs: 12, sm: 5 }}>
                                        <Card sx={{
                                            boxShadow: BOX_SHADOW,
                                            border: "1px solid #F0F0F0",
                                            p: "32px 22px",
                                            borderRadius: isSmallScreen ? "10px" : "40px",
                                            position: isSmallScreen ? "fixed" : "relative",
                                            bottom: "0",
                                            bgcolor: "#fff",
                                            zIndex: 100,
                                            width: isSmallScreen ? "90%" : "auto",
                                        }}>
                                            <CardContent>
                                                <Typography variant="h5" sx={{ display: "flex", alignItems: "center" }}>
                                                    <CurrencyRupeeIcon sx={{ color: "red.main" }} />
                                                    {totalPrice || '0'}
                                                </Typography>
                                                <CustomDivider size="1rem" />


                                                {renderAccordian()}



                                                <CustomDivider size="1rem" />
                                            </CardContent>
                                            <Button variant="contained" fullWidth onClick={handlePayment}>Purchase Now</Button>
                                        </Card>
                                    </Grid2>
                                )}
                            </Grid2>
                        </Box>

                        {isSmallScreen && (
                            <Box sx={{ position: 'fixed', bottom: 0, width: '100%', zIndex: 100, bgcolor: "#fff" }}>
                                <Box
                                    onClick={() => setOpen(prev => !prev)}

                                    sx={{
                                        cursor: 'pointer',
                                        display: "flex",
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        p: 1,
                                        boxShadow: "0px -4px 10px -2px rgba(0,0,0,0.15)"
                                    }}
                                >
                                    <ExpandLessIcon
                                        sx={{
                                            transform: open ? 'rotate(180deg)' : 'rotate(0)',
                                            transition: '0.3s',
                                        }}
                                    />
                                </Box>

                                <Collapse in={open} orientation="vertical" unmountOnExit>
                                    <Box sx={{
                                        height: "10rem",
                                        width: '100%',
                                        bgcolor: '#fff',
                                        boxShadow: true ? 'none' : '0px -4px 10px -2px rgba(0,0,0,0.15)',
                                        p: 2,
                                        borderTopLeftRadius: isSmallScreen ? '10px' : '20px',
                                        borderTopRightRadius: isSmallScreen ? '10px' : '20px',
                                        overflowY: 'auto',
                                    }}>
                                        {renderAccordian()}
                                    </Box>
                                </Collapse>
                                <Card
                                    sx={{
                                        boxShadow: 'none',
                                        borderRadius: isSmallScreen ? '10px' : '40px',
                                        bgcolor: '#fff',
                                        width: '100%',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                    }}
                                >
                                    <CardContent
                                        sx={{
                                            boxShadow: true ? "none" : '0px -1px 5px rgba(0,0,0,0.1)',
                                            width: '100%',
                                        }}
                                    >
                                        <Box sx={{ display: 'flex', gap: '1rem', p: '1rem' }}>
                                            <Box>
                                                <Typography variant="body2" color="grey.400">Total Price</Typography>
                                                <Typography variant="h5" sx={{ display: 'flex', alignItems: 'center' }}>
                                                    <CurrencyRupeeIcon sx={{ color: 'red.main' }} />
                                                    {totalPrice || '0'}
                                                </Typography>
                                            </Box>
                                            <Button variant="contained" fullWidth onClick={handlePayment}>Purchase Now</Button>
                                        </Box>
                                    </CardContent>
                                </Card>
                            </Box>
                        )}
                    </>
                ),
                action: () => !!accordionChecks2[milestoneIndex]?.sprints?.[sprintIndex]?.checked,
                onActionChange: (checked) => handleAccordionCheckChange(milestoneIndex, sprintIndex, checked),
            }));
        }).reduce((acc, tabArray, idx) => {
            acc[`tab${idx}`] = tabArray;
            return acc;
        }, {});
    }, [accordionChecks2, newCoursesDetail, openIndexes, open]);

    const [sprintTabs, setSprintTabs] = useState({});
    const handleChangeSprints = (milestoneIndex) => (event, newValue) => {
        setSprintTabs(prev => ({ ...prev, [milestoneIndex]: newValue }));
    };


    const tabData1 = useMemo(() => {
        if (!newCoursesDetail || accordionChecks2.length === 0) return [];

        return newCoursesDetail.data[0].milestones.map((milestone, index) => {
            const tabs = allTabs[`tab${index}`] || [];
            const selectedSprint = sprintTabs[index] || 0;

            return {
                label: milestone?.milestone_name,
                component: (
                    <>
                        <TopSection sem_number={index + 1} price={100} item={milestone} />
                        <TabForSprints
                            isCheckBox
                            tabs={tabs}
                            value={selectedSprint}
                            onChange={handleChangeSprints(index)}
                        />
                        {tabs.map((tab, idx) => (
                            <TabPanel key={idx} value={selectedSprint} index={idx}>
                                {tabs[selectedSprint]?.component}
                            </TabPanel>
                        ))}
                    </>
                )
            };
        });
    }, [newCoursesDetail, accordionChecks2, sprintTabs, openIndexes, open]);



    return (
        <Box >
            <Box px={Page_Padding}>
                <Typography variant='h1'>{newCoursesDetail?.data?.[0]?.course_name}</Typography>

                {newCoursesDetail?.data?.[0]?.description && <>
                    <Typography variant='body1' color='grey.400' mb={1}>
                        Description
                    </Typography>
                    <Typography variant='body2' color='grey.400'>
                        {newCoursesDetail?.data?.[0]?.description}
                    </Typography>
                </>

                }
                <CustomDivider size={"1rem"} />

                {
                    newCoursesDetail?.data?.[0]?.learningoutcome && <>
                        <Typography variant='body1' color='grey.400' mb={1}>
                            Learning Outcome
                        </Typography>
                        <Typography variant='body2' color='grey.400'>
                            {newCoursesDetail?.data?.[0]?.learningoutcome}
                        </Typography>
                    </>
                }
            </Box>


            <CustomDivider size={"2rem"} />


            {!isLoading && newCoursesDetail && accordionChecks2.length > 0 && tabData1.length > 0 && (
                <>
                    <TabComponentsForCourse
                        isCheckBox={true}
                        tabs={tabData1}
                        value={value}
                        onChange={handleChange}
                        accordionChecks={accordionChecks2}
                        handleCheckboxChange={handleCheckboxChange}
                        isPadding={true}
                    />
                    {tabData1.map((tab, index) => (
                        <TabPanel key={index} value={value} index={index}>
                            {tab?.component}
                        </TabPanel>
                    ))}
                </>
            )}


        </Box>
    )
}

export default CoursePurchased